import { html, property } from 'lit-element'
import { repeat } from 'lit-html/directives/repeat'
import globalSearchActions from './global-search-actions.styles.scss'
import { ShellElement } from '../../../common/shell-element'
import { executeCommand } from '../../../services/namespaces'
import type { GlobalSearchActionUI, GlobalSearchResultItem } from '../global-search-models'
import { unsafeSVG } from 'lit-html/directives/unsafe-svg'

export interface GlobalSearchActionsProps {
  readonly actions: readonly GlobalSearchActionUI[]
  readonly originalResult?: GlobalSearchResultItem | undefined
  readonly searchString: string
}
export class GlobalSearchActions extends ShellElement implements GlobalSearchActionsProps {
  static readonly tagName = 'goto-global-search-actions'

  @property({ type: Array }) actions: GlobalSearchActionsProps['actions'] = []
  @property({ type: Object }) originalResult?: GlobalSearchActionsProps['originalResult'] = {
    id: '',
    application: '',
    score: 0,
    data: {},
  }
  @property({ type: String }) searchString: GlobalSearchActionsProps['searchString'] = ''

  static get styles() {
    return globalSearchActions
  }

  private convertToParams() {
    const params: unknown[] = [this.searchString]
    if (!this.originalResult?.data) {
      params.unshift(this.originalResult)
    }
    return params
  }

  renderAction(action: GlobalSearchActionUI) {
    return html`
      <chameleon-round-button
        class="action-button"
        variant="secondary"
        @click=${(event: MouseEvent) => {
          event.stopPropagation()
          executeCommand(action.command, this.convertToParams())
        }}
        aria-label=${action.displayName}
        ><chameleon-svg slot="end" class="left">${unsafeSVG(action.icon)}</chameleon-svg>
      </chameleon-round-button>
    `
  }

  render() {
    return html`
      ${repeat(
        this.actions,
        action => action.id,
        action => this.renderAction(action),
      )}
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GlobalSearchActions.tagName]: GlobalSearchActions
  }
}
